import JQuery from 'jquery'

export default {
   props: {
      type: {
         validator(value) {
            // The value must match one of these strings
            return ['general', 'confirmation', 'alert'].indexOf(value) !== -1
         },
         default: 'general'
      }
   },
   data() {
      return {
         isOpen: false
      }
   },
   mounted() {
      JQuery('.content-' + this._uid).hide()
      JQuery('.header-' + this._uid).hide()
   },
   computed: {
      isConfirmation() {
         if (this.type === 'confirmation') {
            return true
         }
         return false
      },
      isAlert() {
         if (this.type === 'alert') {
            return true
         }
         return false
      }
   },
   methods: {
      show() {
         this.isOpen = true
         JQuery('.header-' + this._uid)
            .show(0)
            .animate(
               {
                  height: '74px'
               },
               400
            )

         JQuery('.content-' + this._uid).slideDown(400)
      },
      close() {
         this.isOpen = false
         JQuery('.header-' + this._uid).animate(
            {
               height: '0px'
            },
            300
         )
         JQuery('.content-' + this._uid).slideUp(300)

         // JQuery('.notification__content').slideUp(400)
      }
   }
}
